<template>
  <div class="detail-invoiceinfo-wrap">
    <div class="apply-detail-bottom">
      <div class="etail-bottom-title">
        <h4 class="apply-detail-bottom__title apply-detail-bottom__detail">账单明细（{{tableData.length}}）</h4>
        <div v-if="tableData.length > 0" class="apply-detail-btn yjh-active-btn" @click="changeExport">导出明细</div>
      </div>
      <div class="detail-content-bolck detail-content-bolck__table">
        <!-- 表格 -->
        <!-- is-vertical-resize -->
        <v-table
          class="invoice-table"
          is-horizontal-resize
          style="width:100%"
          :error-content="'暂无数据'"
          :error-content-height="86"
          :columns="innerCol"
          :table-data="data"
          :title-row-height="34"
          :row-height="34"
          title-bg-color="#EBF0F3"
          odd-bg-color="#FFFFFF"
          even-bg-color="#FFFFFF"
          row-hover-color="#EDF5FC"
          :vertical-resize-offset="70"
          :show-vertical-border="false"
        ></v-table>
      </div>
    </div>
  </div>
</template>
<script>
import '@/components/vue-easytable/themes-base/index.css'
import { VTable } from '@/components/vue-easytable'
export default {
  name: 'detailTable',
  components: { VTable },
  data() {
    return {}
  },
  props: {
    data: Array,
    innerCol: Object
  },
  methods: {}
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.apply-detail-bottom {
  padding: 30px 30px 0 30px;
  font-size: 12px;
  .etail-bottom-title {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  .apply-detail-btn {
    font-size: 12px;
    color: $blue;
  }
  .apply-detail-bottom__title {
    font-size: 14px;
    font-weight: 400;
  }
  .apply-detail-bottom__detail {
    margin-bottom: 10px;
  }
  .apply-detail__btn {
    color: $blue;
    text-decoration:underline;
    margin-top: 5px;
  }
  .detail-content-bolck {
    border-bottom: solid 1px $border;
  }
  .detail-content-bolck__none {
    text-align: center;
    padding-top: 52px;
    padding-bottom: 50px;
  }
  .detail-content-bolck__table {
    padding-bottom: 20px;
    border-bottom: none;
  }
  /deep/ .v-table-views .v-table-title-cell {
    padding-right: 0 !important;
    color: $fontBlack;
  }
  .invoice-data-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 12px;
    line-height: 1.5;
    margin-top: 24px;
    & li {
      display: flex;
      align-items: flex-start;
      width: 100%;
      margin-bottom: 20px;
      & > div {
        display: flex;
        align-items: flex-start;
        width: 50%;
      }
      &:last-child {
        margin-bottom: 30px;
      }
    }
  }
  .invoice-label,
  .invoice-value {
    display: inline-block;
    word-break: break-all;
  }
  .invoice-label {
    width: 80px;
    text-align: right;
    &:after {
      content: '：'
    }
  }
  .invoice-value {
    width: 300px;
  }
  .invoice-value-file {
    display: flex;
    align-items: flex-start;
  }
  .invoice-value-btn {
    margin-left: 20px;
    min-width: 65px;
    color: $blue;
    text-decoration: underline;
    & > em:last-child {
      margin-left: 16px;
    }
  }
  .invoice-address {
    & > li {
      width: 50%;
    }
  }
}
</style>
